/* eslint-disable complexity */
/* eslint-disable max-statements */
import React, { useState } from "react";
import styles from "./styles.css";
import serviceIcon from "./images/service-icon.png";
import PropTypes from "prop-types";
import imageNotFound from "./images/image-not-found.png";
import reportNotFound from "./images/report-not-found.png";
import ServiceHistoryRevampModal from "../service-history-revamp-modal/component";
import { NUMBER, LOGIN_SOURCE, LEAD_APPOINTMENT_STATUS } from "../../../constants/app-constants";
import getCarInfo from "../../../utils/helpers/get-car-info";
import ImageSliderModal from "../image-slider-modal/component";
import { getDealerPage } from "../../../utils/helpers/get-dealer-route";
import { useHistory } from "react-router";
import Button from "../../shared/button";
const NO_SERVICE_HISTORY_TEXT = {
    dealer: "Contact the dealer to get the detailed service report.",
    internal: "Service history isn’t available, but this car is fully backed by our quality checks.",
    tesla: "Tesla vehicles don’t follow the same regular servicing pattern as petrol or diesel cars. This one has been quality-checked to Cars24 standards."
};
const CarServiceHistory = ({
    content = {},
    config,
    carhistoryRef,
    openLoginPopupConnect,
    setOnLoginSuccessCallback,
    phoneNumberVerified,
    leadAppointment,
    createClassifiedLeadConnect,
    handleShowLoggedInDealerRedirect,
    dealerInfo
}) => {
    const {serviceHistory = [], serviceHistoryImages = [], isServiceHistoryEligible} = content || {};
    const {isDealerListing, dealerCode} = getCarInfo(content);
    const history = useHistory();
    const [showModal, setShowModal] = useState(false);
    const [showImageModal, setShowImageModal] = useState(false);
    const showImageModalHandler = () => {
        setShowImageModal(!showImageModal);
    };
    const showModalHandler = (showLoginFlow = false) => {
        if (showLoginFlow) {
            if (!isDealerListing) {
                setShowModal(!showModal);
                return;
            }
            const dealerName = dealerInfo?.[dealerCode]?.name || "";
            const dealerRoute = getDealerPage(dealerName, dealerCode);
            if (phoneNumberVerified && leadAppointment?.status === LEAD_APPOINTMENT_STATUS.CONFIRM) {
                history.push(dealerRoute);
                return;
            } else if (phoneNumberVerified && leadAppointment?.status !== LEAD_APPOINTMENT_STATUS.CONFIRM) {
                createClassifiedLeadConnect();
                handleShowLoggedInDealerRedirect(dealerRoute);
                return;
            } else {
                setOnLoginSuccessCallback(() => {
                    history.push(dealerRoute);
                });
                openLoginPopupConnect({
                    additionalInfo: { loginSource: LOGIN_SOURCE.CLASSISFIEDS, source: "Service History", appointmentId: content?.appointmentId}
                });
            }
        } else {
            setShowModal(!showModal);
            return;
        }
    };
    if (!serviceHistory?.length) {
        return (
            <div styleName={"styles.componentWrapper styles.dealerListingWrapper"} ref={carhistoryRef}>
                <div>
                    {/* eslint-disable-next-line no-nested-ternary */}
                    <p styleName={"styles.heading"}>{NO_SERVICE_HISTORY_TEXT[isServiceHistoryEligible ? "tesla" : isDealerListing ? "dealer" : "internal"]}</p>

                    {isDealerListing && <div styleName={"styles.buttonWrapper"}>
                        <Button onClick={() => showModalHandler(true)} text="Contact dealership" variant={"secondary"} />
                    </div>}
                </div>
                <div styleName={"styles.noServicesImageWrapperDealer"}>
                    <img src={reportNotFound} styleName={"styles.reportNotFoundImage"} />
                </div>
            </div>);
    }
    const imageNotFoundStyle = !serviceHistoryImages.length ? "styles.rightPanelimage styles.rightPanelimagenotFound" : "styles.rightPanelimage";
    return (
        <div styleName={"styles.componentWrapper"} ref={carhistoryRef}>
            <p styleName={"styles.heading"}>Car service history report</p>
            <div styleName={"styles.contentWrapper"}>
                <div styleName={"styles.leftPanel"}>
                    {serviceHistory?.slice(0, NUMBER.THREE).map((item, index) => (
                        <div key={index} styleName={"styles.sectionWrap"}>
                            <div className="media" styleName={"styles.mediaContainer"}>
                                <img src={serviceIcon} alt="service" />
                                <div className="media-body">
                                    <p styleName={"styles.date"}>{item.serviceDate}</p>
                                    <p styleName={"styles.serviceDetail"}>{item.serviceCenterAddress}</p>
                                </div>
                            </div>
                            {item?.postService?.odo && <p styleName={"styles.kilometer"}>{item?.postService?.odo} km</p>}
                        </div>
                    ))}
                    {serviceHistory?.length ? <Button variant={"secondary"} onClick={() => showModalHandler(false)} text={`See ${serviceHistory?.length > NUMBER.THREE ? serviceHistory?.length - NUMBER.THREE : ""} more services`} /> : null}
                </div>
                <div styleName={`${imageNotFoundStyle}`}>
                    {serviceHistoryImages?.length > 0 ?
                        <img styleName="styles.serviceHistoryImage" onClick={showImageModalHandler} src={serviceHistoryImages[0]} />
                        :
                        <img src={imageNotFound} />}
                </div>
            </div>
            {showModal && <ServiceHistoryRevampModal config={config} onClose={() => showModalHandler(false)} content={content} />}
            {showImageModal && <ImageSliderModal images={[{image: serviceHistoryImages[0]}]} config={config} onClose={showImageModalHandler} isAbsoluteImageUrls/>}
        </div>
    );
};
CarServiceHistory.propTypes = {
    content: PropTypes.object,
    config: PropTypes.object,
    carhistoryRef: PropTypes.object,
    openLoginPopupConnect: PropTypes.func,
    phoneNumberVerified: PropTypes.bool,
    setOnLoginSuccessCallback: PropTypes.func,
    createClassifiedLeadConnect: PropTypes.func,
    leadAppointment: PropTypes.object,
    dealerInfo: PropTypes.object,
    handleShowLoggedInDealerRedirect: PropTypes.func
};

export default CarServiceHistory;
